import { apiSlice } from "@/shared/api/api-slice"
import type { BusinessPrompt, UpsertPromptRequest } from "@/shared/types/api/business-mode.types"

export const upsertPromptApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessPrompt"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      upsertPrompt: builder.mutation<BusinessPrompt, UpsertPromptRequest>({
        query: request => ({
          url: `/api/v1/business/prompts`,
          method: "PUT",
          body: request
        }),
        invalidatesTags: () => [{ type: "BusinessPrompt" as const }]
      })
    })
  })

export const { useUpsertPromptMutation } = upsertPromptApi
